export default "__VITE_ASSET__Bqy41iKT__"